import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { LoginLayout } from "../../../layouts/Login";
import { CreateForm } from "../components/CreateForm";
import { Button } from "../../../components/Button";

import { loginManagement } from "../../../hooks/api/LoginManagement";
import { Slide, toast, ToastContainer } from "react-toastify";

const ForgottenPassword = () => {
    const { t } = useTranslation("common");
    const formDefs = [
        {
            name: "username",
            label: t("username"),
            required: true,
            hint: t("forgottenPasswordHint")
        },
    ];
    const [forgotPswInfo] = useState({
        username: "",
    });
    const navigate = useNavigate();
    const { useForgotPasswordMutation } = loginManagement;
    const [forgotPassword] = useForgotPasswordMutation();

    const handleErrorMessage = (response) => {
        if(response?.error){
            const errorMessage = response?.error?.responseMessage || t("sentResetLinkSuccess");
            toast.error(errorMessage);
        }else{
            const info = response?.info?.responseMessage || t("sentResetLinkSuccess");
            toast.info(info);
        }
    };

    const handleSubmit = async (values) => {
        try {
            await forgotPassword(values)?.unwrap();
            handleErrorMessage();
        } catch (error) {
            handleErrorMessage(error?.data);
        }
    };

    const handleBack = () => {
        navigate("/sign-up/login");
    };

    return (
        <LoginLayout disableSplashScreen={true}>
            
            <CreateForm formDefs={formDefs} initialValues={forgotPswInfo} onSubmit={(values) => handleSubmit(values)} description={t("forgotPasswordDesc")}>
                <div className="section-login__form-btns">
                    <Button className="" type="button" onClick={handleBack}>
                        {t("back")}
                    </Button>
                    <Button type="submit">{t("sendResetLink")}</Button>
                </div>
            </CreateForm>
        </LoginLayout>
    );
};

export default ForgottenPassword;
